import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,[_c(VCardTitle,[_vm._v("Rekapan Jurnal Bulanan")]),_c(VCardText,[_c('form',{on:{"submit":function($event){$event.preventDefault();return (() => {
          _vm.options.page = _vm.filter.page = 1;
          _vm.get();
        }).apply(null, arguments)}}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12","lg":"6"}},[_c(VBtn,{attrs:{"role":"a","target":"_blank","href":_vm.pdf_url,"text":"","color":"red","dark":""}},[_vm._v(" Export PDF ")])],1),_c(VCol,{attrs:{"cols":"6","lg":"3"}},[_c(VSelect,{attrs:{"label":"Bulan","placeholder":"Pilih Bulan","rules":[(v) => !!v || 'bulan harus dipilih'],"items":_vm.data.bulan},on:{"input":() => {
                _vm.options.page = _vm.filter.page = 1;
                _vm.get();
              }},model:{value:(_vm.filter.bulan),callback:function ($$v) {_vm.$set(_vm.filter, "bulan", $$v)},expression:"filter.bulan"}})],1),_c(VCol,{attrs:{"cols":"6","lg":"3"}},[_c(VTextField,{attrs:{"type":"number","label":"Tahun","placeholder":"Pilih Tahun","rules":[(v) => !!v || 'tahun harus dipilih']},on:{"change":() => {
                _vm.options.page = _vm.filter.page = 1;
                _vm.get();
              }},model:{value:(_vm.filter.tahun),callback:function ($$v) {_vm.$set(_vm.filter, "tahun", $$v)},expression:"filter.tahun"}})],1)],1),_c('button',{attrs:{"type":"submit"}})],1),_c(VDataTable,{attrs:{"footer-props":{
        'items-per-page-options': [5, 10, 20, 50, 100],
      },"disable-sort":"","headers":[
        {
          text: 'Hari, Tanggal',
          value: 'tanggal',
        },
        {
          text: 'Guru',
          value: 'guru.nama',
        },
        {
          text: 'Mata Pelajaran',
          value: 'mata_pelajaran.nama',
        },
        {
          text: 'Pokok Bahasan',
          value: 'pokok_bahasan',
        },
        {
          text: 'Rombel / Ruang / Jam Ke',
          value: 'jadwal',
        },
        {
          text: 'Jml Siswa Hadir',
          value: 'siswa_hadir',
        },
        {
          text: 'Dokumentasi',
          value: 'dokumentasi',
        },
      ],"items":_vm.datas,"loading":_vm.is.loading,"loading-text":"Loading... Please wait","server-items-length":_vm.recordsTotal,"options":_vm.options},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item.jadwal",fn:function({ item }){return [_vm._v(" "+_vm._s(item.rombel ? item.rombel.rombel : "-")+" / "+_vm._s(item.ruang || "-")+" / "+_vm._s(item.jam_kbm_full)+" ")]}},{key:"item.siswa_hadir",fn:function({ item }){return [_vm._v(" "+_vm._s(item.siswa_hadir)+"/"+_vm._s(item.total_siswa)+" ")]}},{key:"item.dokumentasi",fn:function({ item }){return [(item.dokumentasi)?_c(VBtn,{attrs:{"small":"","text":"","color":"blue","role":"a","href":item.dokumentasi_url,"target":"_blank"}},[_vm._v("Lihat")]):_vm._e()]}},{key:"item.tanggal",fn:function({ item }){return [_vm._v(" "+_vm._s(item.hari.toUpperCase())+", "+_vm._s(item.tanggal)+" ")]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }